import styled from 'styled-components';

export const accountManagerStyles = (Component) => styled(Component)`
  button {
    width: 154px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
